import { render } from "./AddStudio.vue?vue&type=template&id=0b0c7e39"
import script from "./AddStudio.vue?vue&type=script&lang=js"
export * from "./AddStudio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__